import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-empty-state-view',
    templateUrl: './empty-state-view.component.html',
    styleUrls: ['./empty-state-view.component.scss'],
    standalone: false
})
export class EmptyStateViewComponent {
    @Input() app_string_title: string;
    @Input() img_url: string;
    constructor() { }
}
